import Vue from 'vue'

export default {
  retrieve (force, cb, errorCb) {
    return Vue.http.get('languages/retrieve', { force: force ? 1 : 0 })
      .then(({ data }) => cb(data), response => errorCb(response))
  },
  download (language, cb, errorCb) {
    return Vue.http.get('languages/download', { languages: [language] })
      .then(({ data }) => cb(data.downloadUrl), response => errorCb(response))
  },
  install (language, cb, errorCb) {
    return Vue.http.get('languages/install', { languages: [language] })
      .then(({ data }) => cb(data), response => errorCb(response))
  },
  uninstall (language, cb, errorCb) {
    return Vue.http.get('languages/uninstall', { languages: [language] })
      .then(cb, response => errorCb(response))
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/languages.js
 **/